(function () {
  const root = document.getElementById('AwaCookieConsent');

  if (!root || root.dataset.initialized === 'true') return;

  root.dataset.initialized = 'true';

  const details = document.getElementById('AwaCookieConsentDetails');
  const status = document.getElementById('AwaCookieConsentStatus');
  const preferences = document.getElementById('AwaConsentPreferences');
  const analytics = document.getElementById('AwaConsentAnalytics');
  const marketing = document.getElementById('AwaConsentMarketing');
  const settingsButton = root.querySelector('[data-consent-action="settings"]');
  const saveButton = root.querySelector('[data-consent-action="save"]');
  const markerKey = 'awa_consent_ui_v2';
  let privacyApi;
  let previouslyFocused;

  function hasStoredChoice() {
    try {
      if (window.localStorage.getItem(markerKey) === '1') return true;
    } catch (error) {
      // Some privacy modes disable localStorage; the first-party cookie below
      // remains available in normal browsers.
    }

    return document.cookie.split(';').some(function (cookie) {
      return cookie.trim() === markerKey + '=1';
    });
  }

  function rememberChoice() {
    try {
      window.localStorage.setItem(markerKey, '1');
    } catch (error) {
      // The cookie is the fallback when localStorage is unavailable.
    }

    document.cookie = markerKey + '=1; Max-Age=31536000; Path=/; SameSite=Lax; Secure';
  }

  function setGoogleConsent(choice) {
    if (typeof window.gtag !== 'function') return;

    window.gtag('consent', 'update', {
      analytics_storage: choice.analytics ? 'granted' : 'denied',
      ad_storage: choice.marketing ? 'granted' : 'denied',
      ad_user_data: choice.marketing ? 'granted' : 'denied',
      ad_personalization: choice.marketing ? 'granted' : 'denied',
      functionality_storage: choice.preferences ? 'granted' : 'denied',
      personalization_storage: choice.preferences ? 'granted' : 'denied',
      security_storage: 'granted',
    });
  }

  function currentChoice() {
    const consent = privacyApi.currentVisitorConsent();

    return {
      preferences: consent.preferences === 'yes' && privacyApi.preferencesProcessingAllowed(),
      analytics: consent.analytics === 'yes' && privacyApi.analyticsProcessingAllowed(),
      marketing: consent.marketing === 'yes' && privacyApi.marketingAllowed(),
    };
  }

  function applyTrackingState() {
    const choice = currentChoice();
    setGoogleConsent(choice);
    return choice;
  }

  function fillForm() {
    const consent = privacyApi.currentVisitorConsent();
    preferences.checked = consent.preferences === 'yes';
    analytics.checked = consent.analytics === 'yes';
    marketing.checked = consent.marketing === 'yes';
  }

  function open(showDetails) {
    previouslyFocused = document.activeElement;
    fillForm();
    details.hidden = !showDetails;
    saveButton.hidden = !showDetails;
    settingsButton.hidden = showDetails;
    settingsButton.setAttribute('aria-expanded', String(showDetails));
    root.hidden = false;
    document.documentElement.classList.add('awa-cookie-consent-open');

    window.requestAnimationFrame(function () {
      (showDetails ? preferences : root.querySelector('[data-consent-action="accept"]')).focus();
    });
  }

  function close() {
    root.hidden = true;
    status.textContent = '';
    document.documentElement.classList.remove('awa-cookie-consent-open');

    if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
      previouslyFocused.focus();
    }
  }

  function setButtonsDisabled(disabled) {
    root.querySelectorAll('button').forEach(function (button) {
      button.disabled = disabled;
    });
  }

  function storeChoice(choice) {
    status.textContent = 'Deine Auswahl wird gespeichert …';
    setButtonsDisabled(true);

    if (window.Cookiebot && typeof window.Cookiebot.submitCustomConsent === 'function') {
      // Keep Cookiebot aligned when its external script is available. Shopify
      // still records the choice if a browser or content blocker blocks it.
      try {
        window.Cookiebot.submitCustomConsent(
          choice.preferences,
          choice.analytics,
          choice.marketing
        );
      } catch (error) {
        console.warn('Cookiebot consent synchronization failed.', error);
      }
    }

    privacyApi.setTrackingConsent(choice, function (result) {
      setButtonsDisabled(false);

      if (result && result.error) {
        status.textContent = 'Die Auswahl konnte nicht gespeichert werden. Bitte versuche es erneut.';
        return;
      }

      rememberChoice();
      applyTrackingState();
      close();
    });
  }

  root.addEventListener('click', function (event) {
    const button = event.target.closest('[data-consent-action]');
    if (!button || !privacyApi) return;

    const action = button.dataset.consentAction;

    if (action === 'accept') {
      storeChoice({ preferences: true, analytics: true, marketing: true });
    } else if (action === 'reject') {
      storeChoice({ preferences: false, analytics: false, marketing: false });
    } else if (action === 'settings') {
      open(true);
    } else if (action === 'save') {
      storeChoice({
        preferences: preferences.checked,
        analytics: analytics.checked,
        marketing: marketing.checked,
      });
    }
  });

  document.addEventListener('keydown', function (event) {
    if (root.hidden || event.key !== 'Escape') return;

    const consent = privacyApi && privacyApi.currentVisitorConsent();
    const choiceWasMade = consent && ['preferences', 'analytics', 'marketing'].every(function (key) {
      return consent[key] === 'yes' || consent[key] === 'no';
    });

    if (choiceWasMade) close();
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('a[href*="/pages/cookie-einstellungen"]') || !privacyApi) return;

    event.preventDefault();
    open(true);
  });

  window.AWAConsent = {
    showPreferences: function () {
      if (privacyApi) open(true);
    },
  };

  window.Shopify.loadFeatures(
    [{ name: 'consent-tracking-api', version: '0.1' }],
    function (error) {
      if (error || !window.Shopify.customerPrivacy) {
        root.hidden = false;
        status.textContent = 'Die Cookie-Einstellungen konnten nicht geladen werden. Bitte lade die Seite neu.';
        return;
      }

      privacyApi = window.Shopify.customerPrivacy;
      applyTrackingState();

      const consent = privacyApi.currentVisitorConsent();
      const hasCompleteChoice = ['preferences', 'analytics', 'marketing'].every(function (key) {
        return consent[key] === 'yes' || consent[key] === 'no';
      });

      if (!hasStoredChoice() && (!hasCompleteChoice || privacyApi.shouldShowBanner())) {
        open(false);
      }
    }
  );
})();
